import React, { FC } from 'react';
import TrackShipmentResult from '../../components/trackShipment-v2/trackShipmentResult';
import pageWrapper from '../../hoc/pageWrapper';
import IMediaItem from '../../interfaces/umbracoNodes/mediaItem';
import { IPageViewContentModel } from '../../interfaces/umbracoNodes/pageViewModel';
import IUrlPickerItem from '../../interfaces/umbracoNodes/urlPickerItem';
import PageContentSliceMapper from '../pageContentSlice';

type TExtendedValues = IPageViewContentModel['Values'] & {
	InvalidNumberErrorIcon: IMediaItem;
	InvalidNumberErrorTitle: string;
	InvalidNumberErrorDescription: string;
	UnknownNumberErrorIcon: IMediaItem;
	UnknownNumberErrorTitle: string;
	UnknownNumberErrorDescription: string;
	UnknownNumberRedirectLink: IUrlPickerItem;
};

interface ITrackShipmentModel extends IPageViewContentModel {
	Values: TExtendedValues;
}

interface Props {
	page: ITrackShipmentModel;
}

const TrackShipment: FC<Props> = ({ page }) => {
	return (
		<PageContentSliceMapper page={page}>
			<TrackShipmentResult
				invalidNumberErrorIcon={page.Values.InvalidNumberErrorIcon}
				invalidNumberErrorTitle={page.Values.InvalidNumberErrorTitle}
				invalidNumberErrorDescription={page.Values.InvalidNumberErrorDescription}
				unknownNumberErrorIcon={page.Values.UnknownNumberErrorIcon}
				unknownNumberRedirectLink={page.Values.UnknownNumberRedirectLink}
				unknownNumberErrorTitle={page.Values.UnknownNumberErrorTitle}
				unknownNumberErrorDescription={page.Values.UnknownNumberErrorDescription}
			/>
		</PageContentSliceMapper>
	);
};

export default pageWrapper(TrackShipment);
